import { connect } from 'react-redux';
import ResultsTable from './ResultsTable';

import { getAnnualResults } from '../selectors';
import { setSelectedFinancing } from '../../../../common/settings/actions';

const mapStateToProps = state => ({
    annualResults: getAnnualResults(state),
    selectedFinancing: state.settings.selectedFinancing,
    setSelectedFinancing,
    includeESS: state.ess.includeESS,
    sgipToggle: state.sgip.sgipToggle,
    systemSize: state.solar.systemSize,
    projectState: state.projectaddress.projectState,
    loanTerm: state.loan.loanTerm,
    loanProvider: state.loan.loanProvider,
    mosaicTerm: state.loan.mosaicTerm,
    obsTerm: state.obs.obsTerm,
    capTerm: state.cap.capTerm,
    resiToggle: state.tax.resiToggle,

});

const combinedActions = {
    setSelectedFinancing,
};

export default connect(mapStateToProps, combinedActions)(ResultsTable);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/ResultsTable/index.js